import React from "react";
import {
	Switch,
	Route
} from 'react-router-dom';
import View from './containers/View';
import NotFound from "./containers/NotFound";
import resourcesData from './constants/resourceMap.js';
//var resourceData = import(`${process.env.REACT_APP_RESOURCEMAP}`);
export default function Routes() {
  return (
    <Switch>
      {
        Object.keys(resourcesData).map((key, index)=>(
          <Route exact path={resourcesData[key].path} render={()=>(<View content={resourcesData[key]} key={resourcesData[key]} />) } />
        ))
      }
      <Route render={(props)=>(<React.Fragment><NotFound {...props} /><View content={resourcesData.home} analytics={false} /></React.Fragment>) } />
    </Switch>
  );
}